export class DataService {
  public data: any = {};
}
